import React, { useState } from "react";
import Modal from "react-modal";

const IntroVideoPopup = ({ modalIsOpen, closeModal }) => {
  const [secondModalIsOpen, setSecondModalIsOpen] = useState(false);

  // Detect URL
  const currentPath = typeof window !== "undefined" ? window.location.pathname : "";
  const containerClass = currentPath.includes("ufo-onboarding") ? "UFOSEC" : "PTGCSEC";

  const openSecondModal = () => {
    closeModal();
    setSecondModalIsOpen(true);
  };

  const closeSecondModal = () => setSecondModalIsOpen(false);

  return (
    <>
      <Modal isOpen={modalIsOpen} onRequestClose={closeModal} contentLabel="Modal">
        <div className="My__Overlay">
          <div className="My__OverlayIn">
            <div className="container">
              <div className={`${containerClass} StatisticsSec3 popupcenter`}>
                <button
                  className="nobg closepopup d-flex align-items-center gap-1"
                  onClick={closeModal}
                >
                  <span className="underline">Close</span>
                  <img src="./images/XCircle.svg" className="img-fluid" />
                </button>

                <div className="text-center">
                  <h2 className="mb-4 mt-2 w-100 good_times goldFont">Intro Video</h2>
                </div>

                <div className="cryptoDownload">
                  <div className="row justify-content-center">
                    <div className="col-sm-8">
                      <div className="subcontent subPad text-center p-3 introVideo">
                        <video
                          width="100%"
                          height="460"
                          controls
                          autoPlay
                          loop
                          muted
                          style={{ borderRadius: "20px", boxShadow: "0 4px 20px rgba(0,0,0,0.3)" }}
                        >
                          <source src="https://stats.goptgc.com/videos/ptgc-intro.MP4" type="video/mp4" />
                          Your browser does not support the video tag.
                        </video>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default IntroVideoPopup;
